import React from 'react'

export default function MarginRight({ color = '', style = {} }) {
    let fillColor = '#7246B1'
    if (color) fillColor = color
    let className = 'icons-icon'
    return (
        <svg
            className={className}
            style={style}
            xmlns='http://www.w3.org/2000/svg'
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
        >
            <path
                d='M7 4L8.5 4C9.60457 4 10.5 4.89543 10.5 6L10.5 14C10.5 15.1046 9.60457 16 8.5 16L7 16'
                stroke={color}
                strokeWidth='1.25'
                strokeLinecap='round'
            />
            <path d='M13.5 7L13.5 13' stroke={color} strokeWidth='1.25' strokeLinecap='round' />
        </svg>
    )
}
